// extracted by mini-css-extract-plugin
export default {"wrapper":"AllFilterButton_wrapper__tNJgw"};